import { render, staticRenderFns } from "./OtherAnswer.vue?vue&type=template&id=6966c35a&"
import script from "./OtherAnswer.vue?vue&type=script&lang=js&"
export * from "./OtherAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports